import { motion } from "framer-motion";

interface CelebrationHeaderProps {
  visible: boolean;
}

const CelebrationHeader = ({ visible }: CelebrationHeaderProps) => {
  if (!visible) return null;

  return (
    <motion.div
      className="text-center"
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, type: "spring" }}
    >
      <motion.h1
        className="text-4xl font-extrabold italic text-orange-500 md:text-5xl"
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        Woohoo!
      </motion.h1>
      <motion.p
        className="mt-2 text-xl font-bold text-emerald-600"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        You got it all right!
      </motion.p>
    </motion.div>
  );
};

export default CelebrationHeader;